module.exports = __webpack_public_path__ + "static/media/ses-water-management.110c86cd.jpg";